export default{
  'engagement_register_New': '新进', // 1
  'engagement_register_Total_Register_User': '总新进用户', // 2
  'engagement_register_New_Register_Users': '新进用户', //3
  'engagement_register_Today': '当日', // 4
  'engagement_register_This_Week': '当周',
  'engagement_register_This_Month': '当月',
  'engagement_register_Last_Year': '去年同期',
  'engagement_register_SDLW': '上周同期', // 5
  'engagement_register_SWLM': '上月同期',
  'engagement_register_SMLY': '去年同期',

  'engagement_register_legend_SDLW': '上周同期', // 5
  'engagement_register_legend_SWLM': '上月同期',
  'engagement_register_legend_SMLY': '去年同期',
  'engagement_register_Register_Users_Country_Distribution': '新进用户国家构成', // 1
  'engagement_register_Register_Users_Channel_Distribution': '新进用户渠道构成', // 2
  'engagement_register_Register_Users_Media_Channel_Distribution': '新进用户买量渠道构成',
  'engagement_register_Register_Users_Platform_Distribution': '新进用户平台构成',

  'engagement_register_Register_Users':'新进用户',

  // Country/Region/Zone Breakdown 模块
  'engagement_register_Country/Region/Zone_Breakdown': '国家/区域/区服排行榜', // 1
  'engagement_register_Country': '国家',
  'engagement_register_New_of_top_10_Countries': '新进用户 Top 10 国家',
  'engagement_register_Region': '区域',
  'engagement_register_New_of_top_10_Regions': '新进用户 Top 10 区域',
  'engagement_register_Zone': '区服',
  'engagement_register_New_of_top_10_Zones': '新进用户 Top 10 区服',
  'engagement_register_Channel': '渠道',
  'engagement_register_New_of_top_10_Channels': '新进用户 Top 10 渠道',
  'engagement_register_Platform': '平台',
  'engagement_register_New_of_top_10_Platform': '新进用户 Top 10 平台',

    // Country/System/Language Breakdown 模块
    'engagement_register_Country/System/Language_Breakdown': '国家/平台/语言排行榜', // 1
    'engagement_register_System': '平台',
    'engagement_register_New_of_top_10_Systems': '新进用户 平台',
    'engagement_register_Language': '语言',
    'engagement_register_New_of_top_10_Languages': '新进用户 语言',
    

  'engagement_register_Share_Of_All': '全局占比',
  'engagement_register_Sum_New': '新进总数',


  'engagement_register_Sum_New_Role_Count': '新进用户使用的新角色数量统计', // 1
  'engagement_register_Sum_Total_New_Role_Counts': '新进角色数量', // 2
  'engagement_register_Role': '角色',
  'engagement_register_Date': '日期',
  'engagement_register': '新进',
}